import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles({
  root: {
    '& input': {
      height: '1.2em',
    },
    '& select': {
      height: '1.2em',
      lineHeight: '1.35',
    },
  },
  padded: {
    '& input': {
      padding: '16px 14px',
    },
    '& select': {
      padding: '16px 14px',
    },
  },
  fontSize: {
    fontSize: '1.063rem',
  },
  placeholderColor: {
    color: '#999999',
  },
  shrinkColor: {
    color: '#4B4B4B',
  },
  helperText: {
    fontWeight: '400',
    fontSize: '0.75rem',
  },
});

function ProfileTextField({
  error,
  field,
  plain,
  required = false,
  type = 'text',
  value,
  onChange,
}) {
  const classes = useStyles();
  const [siteCopy] = useSiteCopySelector(['sign-up']);

  return (
    <TextField
      id={field}
      name={field}
      label={_get(siteCopy, ['pageCopy', `${field}Placeholder`])}
      classes={{
        root: _classNames(classes.root, { [classes.padded]: !plain }),
      }}
      InputProps={{
        classes: {
          root: classes.fontSize,
        },
      }}
      InputLabelProps={{
        classes: {
          root: _classNames(classes.fontSize, classes.placeholderColor),
          shrink: classes.shrinkColor,
        },
      }}
      error={error}
      helperText={
        error ? _get(siteCopy, ['pageCopy', `${field}Error`]) : undefined
      }
      FormHelperTextProps={{
        classes: {
          root: classes.helperText,
        },
      }}
      onChange={onChange}
      value={value}
      fullWidth
      type={type}
      variant={plain ? 'standard' : 'outlined'}
      autoComplete="off"
      required={required}
    />
  );
}

ProfileTextField.propTypes = {
  error: PropTypes.bool,
  field: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  plain: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default ProfileTextField;
